import React, { useContext, useEffect } from 'react';

import RegistrationFormRow from './RegistrationFormRow'
import RegistrationFormSection from './RegistrationFormSection';
import { useTranslation, Trans } from 'react-i18next';
import RegistrationFormCountry from './RegistrationFormCountry';
import EventContext from '../contexts/EventContext';

const RegistrationFormContactAndOrganismeSection = ({ contact }) => {

    const { t, i18n } = useTranslation();

    const eventContext = useContext(EventContext);

    const { currentEvent } = eventContext;

    useEffect(() => {

    }, [i18n.resolvedLanguage, contact])

    return <RegistrationFormSection title={t('form.sections.contact_and_organisation_section.section_title')}>

        <> <RegistrationFormRow
            name='prenom'
            placeholder={t('form.sections.contact_section.prenom')}
            defaultValue={contact?.prenom} />

            <RegistrationFormRow
                name='nom'
                placeholder={t('form.sections.contact_section.nom')}
                defaultValue={contact?.nom} />

            <RegistrationFormRow
                name='fonction'
                placeholder={t('form.sections.contact_section.fonction')}
                defaultValue={contact?.fonction}
            />

            <RegistrationFormRow
                name='port'
                placeholder="Mobile"
                defaultValue={contact?.port}
            />
        </>


        <RegistrationFormRow
            name='mail'
            placeholder="E-mail"
            defaultValue={contact?.mail} />

        <RegistrationFormRow
            name='societe'
            placeholder={t('form.sections.organisme_section.societe')}
            defaultValue={contact?.societe} />
        {/* 
        <RegistrationFormRow
            isRegister
            inputType="textarea"
            name='edito_long'
            placeholder={t('form.sections.organisme_section.edito_long')}
            required={false}
            defaultValue={contact?.edito_long} />

             
        */}
        <RegistrationFormCountry required={true} />

        <RegistrationFormRow
            inputType="file"
            name='photo'
            placeholder={t('form.sections.contact_section.photo')}
            defaultValue={contact?.photos.large}
            required={contact?.photos.large != '' ? false : true}
            accept={['.jpeg', '.png', '.jpg']} />

        <RegistrationFormRow
            inputType="file"
            name='logo'
            placeholder={t('form.sections.organisme_section.logo')}
            defaultValue={contact?.logos.large}
            required={contact?.logos.large != '' ? false : true}
            accept={['.jpeg', '.png', '.jpg']} />


        <hr className='mb-3' />
        <h4 className="row pl-5  pb-3 text-2xl font-bold">
            {t('form.sections.contact_and_organisation_section.video_section_title')}
        </h4>
        <RegistrationFormRow
            required={false}
            textLabel="Option 1"
            inputType="text"
            name='organisme_video_url'
            placeholder=""
            helper={t('form.sections.contact_and_organisation_section.video_url_helper')}
            defaultValue={contact?.organisme_video_url} />

        <RegistrationFormRow
            required={false}
            inputType="file"
            name='organisme_video_hosted'
            placeholder="Option 2"
            helper=""
            defaultValue={contact?.organisme_video_hosted}
            accept={[
                //video format

                ".mp4",
                ".avi",
                ".mov",
                ".flv",
                ".wmv",
                ".webm",
                ".mkv",


            ]} />

    </RegistrationFormSection>
}

export default RegistrationFormContactAndOrganismeSection;
